export default import.meta.ROLLDOWN_FILE_URL_xUfAOc8vsLn5godiQWqFgA